import React, { useEffect, useMemo, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteStagesStudy, getStagesStudy } from '../../actions/stagesStudy'

export default function StagesStudy() {
  const dispatch = useDispatch()
  const { stageStudyList } = useSelector(state => state.stages_study)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false)
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getStagesStudy())
  }, [])

  const sortedList = useMemo(() => {
    if (!stageStudyList) return []
    return [...stageStudyList].sort((a, b) => sortAsc
      ? a.name?.localeCompare(b.name, 'ru')
      : b.name?.localeCompare(a.name, 'ru'))
  }, [stageStudyList, sortAsc])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    closeModal()
    dispatch(deleteStagesStudy(confirmation.id))
    setConfirmation(false)
  }
  const rejectConfirmation = () => {
    setConfirmation(false)
  }

  const renderLi = (data) => {
    const { f_studysteps, name } = data
    return (
      <tr key={f_studysteps} onClick={openModal(data)}>
        <td>{name}</td>
        <td>
          <button
            type="button"
            className={styles.deleteBtn}
            onClick={(e) => { e.stopPropagation(); setConfirmation({ id: f_studysteps, name }) }}
            title="Удалить запись"
            aria-label="Удалить"
          >
            <BiTrash size={20} />
          </button>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить "${confirmation.name}"?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
        />
      }
      <header className={styles.header}>
        <h1>Ступени обучения</h1>
      </header>
      <main className={styles.content}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th onClick={() => setSortAsc(v => !v)} style={{ cursor: 'pointer' }}>Название</th>
              <th style={{ width: '70px' }}>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {sortedList.map(renderLi)}
          </tbody>
        </Table>
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {sortedList.length}</span>
        </div>
      </main>
    </div>
  )
}
